<span class="data-types {{ size }}">
  <app-ce-icon [name]="Type" [size]="11" [svg_class]="['d-flex', 'primary-60']"></app-ce-icon>
</span>
<ng-content></ng-content>
